const Paymentss = () => import('../views/user/Payment')
const PaymentDetails = () => import('../views/user/PaymentDetails')

const AdminTransactions = () => import('../views/admin/Transactions')
const AdminTransactionDetails = () =>
  import('../views/admin/TransactionDetails')

import DefaultLayout from '@/layouts/DefaultLayout'
import store from '@/store/index'

export default [
  {
    path: '/payments',
    name: 'Paymentss',
    component: DefaultLayout,
    redirect: '/wallet',
    async beforeEnter(to, from, next) {
      if (screen.width <= 768) {
        // store.commit({
        //   type: 'updateSidebarVisible',
        //   value: store.state.sidebarVisible,
        // })
        store.commit('setSidebar', false)
      }
      try {
        var hasPermission = await store.getters.get_access_token
        if (hasPermission) {
          next()
        } else {
          next({
            name: 'Login', // back to safety route //
            query: { redirectFrom: to.fullPath },
          })
        }
      } catch (e) {
        next({
          name: 'Login', // back to safety route //
          query: { redirectFrom: to.fullPath },
        })
      }
    },
    children: [
      {
        path: '/payments',
        name: 'user.payments.index',
        component: Paymentss,
      },
      {
        path: '/payments/:id',
        name: 'user.payments.show',
        component: PaymentDetails,
        meta: {
          layout: 'default',
          auth: true,
          guard: 'user',
          title: 'Payment Details',
        },
      },
      {
        path: '/admin/transactions',
        name: 'admin.transactions.index',
        component: AdminTransactions,
        meta: {
          layout: 'default',
          auth: true,
          guard: 'admin',
          permission: 'view-transaction',
          title: 'Transactions',
        },
      },
      {
        path: '/admin/transactions/:id',
        name: 'admin.transactions.show',
        component: AdminTransactionDetails,
        meta: {
          layout: 'default',
          auth: true,
          guard: 'admin',
          permission: 'view-transaction',
          title: 'Transaction Details',
        },
      },
    ],
  },
]
